/**
 * Created by shbs on 08/06/2018.
 */
export default {
  zh: {
    message: {
      Operation: "操作",
      select: "请选择",
      submit: "提交",
      query: "查询",
      cancel: "取消",
      lookat: "查看",
      Edit: "编辑",
      besuer: "确认",
      Approval: "审批",
      Reject: "驳回到第一步",
      Rejectnext: "驳回到上一步",
      Resubmit: "重新提交",
      Reset: "重置",
      download: "下载",
      needcomName: "请输入公司名称",
      needassignment: "请输入签约任务量",
      needemail: "请输入联系人邮箱",
      needecountry: "请选择国家",
      needauthcountry: "请选择授权区域",
      needecity: "请选择区域",
      needesalesName: "请输入锐捷销售姓名",
      needesalesphone: "请输入锐捷销售手机",
      needesetUpDate: "请选择公司成立日期",
      needeaddress: "请输入公司地址",
      needepeopleNumber: "请输入公司人数",
      needepartnerType: "请输入所属VAD",
      needecontractValidity: "请输入合同有效期",
      needeApplicationReason: "请输入申请理由",
      needRegisteredCapital: "请输入注册资金",
      needname: "请输入姓名",
      needPosition: "请输入职位",
      needMobile: "请输入手机号",
      needEmail: "请输入邮箱",
      needoffphone: "请输入办公电话",
      needeparentCompanyCode: "请选择所属VAD",
      needBusinessFocus: "请选择业务聚焦",
      needIndustryFocus: "请选择行业聚焦",
      needIndustryFocusOther: "请输入行业聚焦",
      needbeemail: "请输入正确的邮箱格式",
      needfile: "请上传文件",
      uploadError: "上传失败",
      submitError: "提交失败",
      submitsuccess: "提交成功",
      complianceBlockTitle: "出口合规检测未通过",
      complianceRiskDetails: "命中风险明细",
      complianceRiskLevel: "风险等级：{level}",
      complianceClose: "关闭",
      complianceConfirm: "确认",
      complianceAppealMissing: "合规申诉参数缺失，请稍后重试",
      complianceAppealSuccess: "申诉已发起",
      complianceAppealSuccessNo: "申诉已发起，拦截处理单号：",
      complianceAppealFailed: "发起申诉失败，请稍后重试",
      complianceFallback: "出口合规检测未通过，请联系管理员",
      complianceReviewPending: "该签约已发起出口合规审查（审查单号：{no}），正在处理中，请等待审查结果。",
      complianceReviewRejected: "该签约的出口合规审查未通过（审查单号：{no}），请联系管理员。",
      bindsuccess: "绑定成功",
      approveAgree: "通过审批",
      approveReject: "已驳回",
      bindAccount: "绑定账号",
      add: "+ 新建",
      activation: "激活",
      activationsuccess: "激活成功",
      disable: "禁用",
      disablesuccess: "禁用成功",
      link: "链接",
      none: "无",
      release: "发布",
      releasesuccess: "发布成功",
      confirmDisable: "确认禁用吗？",
      confirmActive: "确认激活吗？",
      hints: "提示",
      secondHints: "再次确认",
      save: "暂存",
      savesuccess: "保存成功",
      notnull: "必填项",
      manage: "管理",
      manageUser: "管理用户",
      manageInterface: "管理接口权限",
      manageMenu: "管理菜单权限",
      noimage: "未上传图片",
      addChildArea: "新增子区域",
      addParentArea: "新增父区域",
      needCompanyEmail: "请输入公司邮箱",
      rejectMessage: "驳回原因",
      bindChannel: "绑定账号",
      confirmDelete: "确定要删除吗？",
      needFirstName: "请输入名",
      needLastName: "请输入姓",
      needPassword: "请输入密码",
      needBePassword:
        "密码长度8-16位，必须包含大小写字母和数字，账号和密码不可以完全一致",
      needPhone: "请输入电话号码",
      needCompany: "公司不能为空",
      needPositions: "请选择职位",
      emailNotExistsAndRegister:
        "账号邮箱不存在,请联系邮箱使用者在如下链接创建账号。",
      needIdentifyCode: "请输入证件号",
      bindRgid: "绑定",
      neednamePinyin: "请输入名称拼音",
      delete: "删除",
      confirm: "确定",
      pendingApprove: "待审批",
      pass: "审批通过",
      approveAgreeMessage: "您确定要审核通过吗？",
      operationSuccess: "操作成功",
      needMasterAccount: "请选择主账号",
      approAgree: "审批通过",
      approReject: "拒绝",
      deleteSuccess: "删除成功",
      needNewBindAccount: "请填写新绑定渠道账号",
      RejectReason: "驳回理由 :",
      rgidGuide:
        "• RGID是每个考生参加锐捷认证考试的唯一身份标识，一次获取终身有效。您必须使用RGID进行报名考试、成绩查询与证书查询，如果您已经获得过RGID，您可以登录后进入“个人中心”查看您的RGID。",
      waitUpload: "请等待附件上传完成",
      needOpinion: "请输入审批意见",
      agree: "同意",
      needSalution: "请选择尊称",
      needMobileNumber: "请输入手机号",
      excel: "Excel",
      backpackerReport: "导出背包客报告",
      targetyearnotnull: "请输入年份",
      targetyearinvalid: "请输入有效年份",
      numeric: "请输入一个正整数",
      targetAdd: "新增销售目标",
      targetEdit: "编辑销售目标",
      partnerTarget: "销售目标",
      received: "确认领取",
      userNameNeedLetters: "姓名必须是英文字母",
      bindTips: "注意：注册名称将出现在证书上，包括空白符号。请仔细核实。",
      identityTips: "建议使用个人识别码",
      deleteReason: "删除理由",
      needOrderAmount: "请输入下单金额",
      needBeAmount: "请输入12位以内的正数",
      needPoPicture: "请上传PO单",
      needBePicture: "请上传 JPG,JPEG, GIF, PNG, BMP, RAR 或 ZIP 格式的文件",
      approver: "审批人",
      needCooperationPlanUrl: "请上传合作计划书",
      needRebateCoefficient: "请输入返利系数",
      needSaleTargetQ1: "请输入Q1任务量",
      needSaleTargetQ2: "请输入Q2任务量",
      needSaleTargetQ3: "请输入Q3任务量",
      needSaleTargetQ4: "请输入Q4任务量",
      certificate: "授权函",
      renewal: "续签",
      use: "使用",
      needApprovalOpinion: "请输入审批意见",
      needAuthRegion: "请选择授权国家"
    },
    menu: {
      channecontract: "待处理签约列表",
      channecontractlist: "待处理签约列表",
      ContractInfo: "签约信息",
      ContractInfolist: "签约列表"
    },
    page: {
      home: {
        Announcement: "公告",
        pictitle1: "Find Partner",
        pictitle2: "Become  Partner",
        partenr: "合作伙伴",
        VAD: "VAD合作伙伴",
        goldpartner: "金牌合作伙伴",
        CertifiedPartner: "认证合作伙伴",
        FranchisedPartner: "特许合作伙伴",
        usercenter: "用户中心",
        banerTtile1: "Tools & Resources",
        banerTtile2: "Launch of  Parnter Management System",
        banercon:
          "Login in to view all tools and resources available to our partners",
        banerbtn: "Resources Center",
        VADdetaile:
          "VAD是锐捷最紧密的合作伙伴，负责分销锐捷产品，建设锐捷的品牌，同时为reseller提供更多的增值服务和支持。在产品线的组合、供货服务、reseller的信用控制、销售界面等方面提供增值服务。",
        golddetaile:
          "行业金牌合作伙伴面向授权内的客户销售锐捷网络产品，可以向锐捷网络的总代下单，仅允许向最终客户供货，不允许供货给其他合作伙伴，遵守锐捷的市场和价格秩序，要求有一定的签约任务量。",
        Certificationdetaile:
          "认证合作伙伴面向授权范围内的客户销售锐捷网络产品，可以向锐捷网络总代下单，仅允许向最终客户供货，不允许供货给其他合作伙伴，遵守锐捷的市场和价格秩序无签约任务量要求。",
        Strategydetaile:
          "战略合作伙伴面向授权范围内的运营商、金融、政府、军工、交通、电力、能源等大客户销售锐捷网络产品，仅允许向最终用户供货。"
      },
      ContractInfolist: {
        codeSigning:'渠道编码',
        signContract:'签约国家',
        contractSales:'签约销售',
        ContractList: "签约列表",
        ContractInformation: "签约信息",
        companycode: "公司编码",
        comname: "公司名称",
        target: "任务量(万/美元)",
        TypeofContract: "签约类型",
        YearofContract: "签约年份",
        DateofContract: "签约时间",
        contractvalid: "签约有效期至"
      },
      channelUserEditVAD: {
        title: "编辑合作伙伴"
      },
      VAD: {
        // VAD 签约方式,新增翻译
        overallAssessmentTasks:'任务量',
        sharpNetworkRebatesCoefficient:'睿网络返点系数',
        easyNetworkRebatesCoefficient:'易网络返点系数',
        homeNetworkRebatesCoefficient:'家用返点系数',
        amountHouseholdTasks:'家用任务量',
        overallAssessment:'整体考核',
        separateInspection:'分开考核',
        assessmentMethods:'考核类型',
        quarterlyAssessmentWay:'季度考核方式',
        basetitle: "基本信息",
        comname: "公司名称",
        Target: "销售目标",
        rebateTarget: "返利目标",
        rebateCoefficient: "返利系数",
        saleRewardCoefficient: "销售奖励系数",
        quarterlyTasks: "季度分解任务",
        quarterlyTasksMustEquals: "季度分解任务之和必须等于目标数",
        Targetunt: "(万/美元)",
        email: "联系人邮箱",
        nation: "国家",
        authRegion: "授权区域",
        region: "区域",
        ruijieSR: "锐捷销售姓名",
        ruijieSRemail: "锐捷销售邮箱",
        ruijieSRphone: "锐捷销售手机",
        contractvalid: "合同有效期至",
        agreementup: "协议上传",
        cooperationPlan: "合作计划书",
        agreementfile: "双方盖过章的协议",
        upload: "上传",
        detiltitle: "详细信息",
        datefond: "公司成立日期",
        companyadress: "公司地址",
        companynum: "公司人数",
        addvad: "签约VAD合作伙伴信息",
        raddvad: "签约合作伙伴信息",
        addgold: "签约金牌合作伙伴信息",
        VADType: "所属VAD",
        Certifiedadd: "签约认证合作伙伴信息",
        YPadd: "签约YP合作伙伴信息",
        SUBadd: "签约SUB合作伙伴信息",
        ZCPartnerad: "签约注册合作伙伴信息",
        ApplicationReason: "审批理由",
        FranchisedPartneradd: "签约特许合作伙伴信息",
        peopleNumber: "公司人数",
        RegisteredCapital: "注册资金",
        GeneralManager: "总经理信息",
        name: "姓名",
        Position: "职务",
        Mobile: "移动电话",
        Email: "联系邮箱",
        offphone: "办公电话",
        SalesSupervisor: "业务负责人",
        CommercialSupervisor: "商务负责人",
        TechnicalSupervisor: "技术负责人",
        VADInfotitle: "查看VAD合作伙伴",
        CertifiedInfotitle: "查看认证合作伙伴",
        GoldInfotitle: "查看金牌合作伙伴",
        FranchisedInfotitle: "查看特许合作伙伴",
        YPInfotitle: "查看YP合作伙伴",
        SUBInfotitle: "查看SUB合作伙伴",
        ZLInfotitle: "查看战略合作伙伴",
        ZCInfotitle: "查看注册合作伙伴",
        ApprovalProcess: "审批流程",
        nodeList: {
          node: "审批流程",
          Approver: "审批节点",
          status: "审批状态",
          date: "审批时间",
          remarks: "审批意见"
        },
        VerifyVAD: "审核VAD合作伙伴",
        VerifyJP: "审核金牌合作伙伴",
        VerifyRZ: "审核认证合作伙伴",
        VerifyYP: "审核YP作伙伴",
        VerifySUB: "审核SUB合作伙伴",
        VerifyZL: "审核战略合作伙伴",
        VerifyZC: "审核注册合作伙伴",
        OperationLog: {
          title: "操作记录",
          Operator: "操作人",
          item: "操作项",
          time: "操作时间",
          content: "内容"
        },
        RemarksApproval: "审批意见",
        downmb: "下载签约模板",
        downRz: "Ruijie Networks Authorized Partnership Agreement",
        uploadtip:
          "只能上传 JPG,JPEG, GIF, PNG, PPT, DOC, DOCX, PPTX,PPT, RAR 和 ZIP格式的文件，且不超过 50M",
        poPictureUploadTips:
          "只能上传 JPG,JPEG, GIF, PNG, BMP, RAR 和 ZIP格式的文件，且不超过 50M",
        allowImage:
          "只能上传 BMP、JPG、JPEG、PNG、GIF 格式的文件，且不超过 50M",
        GlobalStrategicPartneradd: "签约战略合作伙伴信息",
        CompanyMail: "公司邮箱",
        salesInformation: "锐捷销售信息",
        readAndAgree: "阅读并同意",
        rzDescription:
          "Thank you for applying the Ruijie partner. It is time to complete your information so that we can better serve you . don’t worry, the process is quick and easy.",
        rzStep1:
          "①To let us better help you, please provide all required information before continuing",
        rzStep2:
          "②Please choose your preferred authorized Ruijie Value-added distributor",
        rzStep3:
          "③Note: In order to verify the authenticity of your information, please upload your company’s business license or a photo taken with Ruijie’s VAD staff and sales staff.",
        salution: "Salution ",
        mobileNumber: "Mobile Number",
        remind: "公司名称请填写准确， 填写后无法修改。",
        picUpload: "图片上传",
        tbc: "待定",
        orderAmount: "下单金额",
        poPicture: "PO单",
        businessFocus: "业务聚焦",
        industryFocus: "行业聚焦",
        reyee: "易网络",
        homeNetwork:'家用网络',
        enterprise: "睿网络",
        smb: "SMB"
      },
      pending: {
        ListPending: "待处理签约列表",
        Approvalstate: "审批状态"
      },
      SwitchingIdentity: {
        title: "身份切换"
      },
      RoleManagement: {
        title: "角色管理",
        roleName: "角色名称",
        status: "状态",
        roleCode: "角色编码",
        updateTime: "最后修改时间",
        editRole: "编辑角色"
      },
      UserManagement: {
        title: "用户管理",
        userRole: "用户角色",
        userId: "用户编码",
        userName: "用户姓名",
        userEmail: "用户邮箱",
        state: "状态",
        roleCode: "角色编码",
        updateTime: "最后修改时间",
        phoneNumber: "联系电话",
        active: "激活",
        disable: "禁用",
        editUser: "编辑用户",
        edit: "编辑",
        query: "查询",
        reset: "重置"
      },
      Content: {
        ContentManagement: "信息管理",
        title: "标题",
        status: "状态",
        type: "信息类别",
        content: "内容",
        image: "图片",
        link: "链接",
        updateTime: "最后修改时间"
      },
      ContentForm: {
        contentAdd: "添加信息",
        contentEdit: "修改信息",
        baseInfo: "基础信息",
        isNewWindow: "是否打开窗口",
        isBanner: "是否为Banner",
        linkOfNewWindow: "新窗口网址",
        bannerInfo: "Banner信息",
        title: "标题",
        status: "状态",
        type: "类型",
        content: "内容",
        image: "图片",
        link: "链接",
        uploadImage: "上传图片",
        pcBannerTip: "只能上传 JPG、JPEG、PNG 格式的文件，尺寸限制小于2000*700",
        mobileBannerTip:
          "只能上传 JPG、JPEG、PNG 格式的文件，尺寸限制小于800*500",
        newsContent: "内容",
        permissionInfo: "权限信息",
        regionPermission: "是否限制区域",
        region: "授权区域",
        channelPermission: "渠道权限",
        partnerTypes: "签约类型",
        isLogin: "是否需要登录",
        permission: "访问权限",
        imagePc: "PC端banner图",
        imageMobile: "移动端banner图"
      },
      RoleUser: {
        userRoleManagement: "用户角色管理",
        modify: "修改",
        role: "角色",
        pleaseInput: "请输入",
        notInGroupUsers: "未在组用户",
        list: "列表"
      },
      AreaTableHeader: {
        areaTableTitle: "区域管理",
        levelHeaderName: "级别",
        areaHeaderName: "区域名称",
        upperAreaHeaderName: "所属区域",
        creatTime: "创建时间",
        operate: "操作"
      },
      templ: {
        TemplateManager: "签约模板管理",
        TemplateAdd: "新增模板",
        TemplateEdit: "编辑模板",
        path: "路径",
        fileName: "文件名称",
        templType: "模板类型",
        createTime: "创建时间",
        partnerType: "签约类型"
      },
      RoleMenu: {
        roleMenuManagement: "角色菜单管理",
        modify: "修改",
        menuDisplayPermissions: "菜单显示权限"
      },
      RoleInterface: {
        roleInterfaceManagement: "角色接口管理",
        modify: "修改",
        menuDisplayPermissions: "接口调用权限"
      },
      Account: {
        masterAccountTitle: "账号绑定",
        subAccountName: "子账号姓名",
        subAccount: "子账号",
        subAccountMail: "子账号邮箱",
        workPost: "职位",
        contactPhone: "联系电话",
        operate: "操作",
        addSubAccount: "添加子账号",
        transferToAnother: "转移子账号",
        transferSubAccountNote:
          "注意:转移后，选中子账号将转移到新主账号下且无法修改",
        transferSubAccountSuccess: "子账号转移成功",
        needTransferMasterAccount: "请选择要转移的子账号",
        editSubAccount: "编辑子账号",
        firstName: "名",
        lastName: "姓",
        password: "密码",
        phoneNumber: "电话号码",
        country: "国家/地区",
        company: "公司名称",
        masterAccount: "渠道主账号",
        masterAccountName: "渠道名称",
        status: "状态",
        bindMasterAccount: "绑定渠道主账号",
        changeMasterAccount: "改绑渠道主账号",
        pendingTitle: "待处理绑定列表",
        bindAccount: "已绑定渠道账号",
        newBindAccount: "新绑定渠道账号",
        name: "姓名",
        credentialsType: "证件类型",
        credentialsNum: "证件号码",
        recipient: "证件接收人",
        postAddress: "邮寄地址",
        postCode: "邮编",
        selPhoneNum: "手机号",
        myRgeidTitle: "我的RGID",
        cancel: "取消",
        submitBind: "提交绑定",
        reSubmit: "重新提交",
        showRejectReason: "查看驳回原因",
        approvalMan: "审批人",
        approvalOpinion: "审批意见",
        approvalTime: "审批时间",
        rejectHistory: "驳回历史",
        modify: "修改",
        namePinYin: "姓名拼音",
        typesValidIds: "身份证",
        masterAccountEmail: "主账号邮箱",
        masterAccountInstructions: "如果想要绑定子账号，请点击添加子账号按钮",
        boundVadSaleName: "VAD/Sub-D销售"
      },
      certificate: {
        title: "证书信息",
        certificateCode: "证书编号",
        certificatePreview: "证书预览",
        name: "工程师姓名",
        authenticationName: "认证名称",
        expireDate: "到期时间",
        workPost: "职位"
      },
      resourcesList: {
        category: "类别:"
      },
      InfoCatManagement: {
        parentCat: "父类别",
        rootCat: "一级类别",
        secondCat: "二级类别"
      },
      lier2partnerlist: {
        title: "二级渠道列表",
        email: "邮箱",
        dateRegisterStart: "注册日期自",
        dateRegisterEnd: "注册日期到",
        certified: "认证",
        recertified: "重新认证",
        hints: "请确认公司已完成第一笔订单",
        guid:
          "合作伙伴下第一个订单后，请点击“认证”。 在锐捷销售批准后，合作伙伴将成为锐捷认证合作伙伴。",
        registerNumber: "注册合作伙伴数量",
        certifiedNumber: "认证合作伙伴数量"
      },
      PartnerTargets: {
        targetYear: "年份",
        salesVolumeTarget: "销售任务量",
        targetRegistered: "注册渠道/任务量",
        targetCertified: "认证渠道/任务量",
        targetRegisteTitle: "注册渠道任务量",
        targetCertifTitle: "认证渠道任务量",
        createTime: "创建时间"
      },
      rebate: {
        title: "返点信息",
        company: "VAD公司名称",
        rebateType: "返点类型"
      },
      ApReceive: {
        title: "AP领取登记",
        remind:
          "如果您已经领取AP，请点击已领取按钮，如果未领取，请联系您所属的VAD或者销售",
        confirm: "确认已经领取AP吗？"
      },
      // RAD,RDP签约翻译 2022-6-10
      signUpProcess: {
        basetitle: "基本信息",
        comname: "公司名称",
        Target: "销售目标",
        address: "详细地址",
        website: "公司网站",
        contractgoal: "签约目标",
        contact: "关键联系人",
        email: "关键联系人Email",
        businesslicense: "营业执照",
        contractAgreement: "签约协议",
        businessPlan: "业务规划书",
        approveCountrManager: "国家经理审批",
        approveRegionalManager: "国际大区总经理审批",
        rejectToFirstNode: "驳回到第一节点",
        rebateTarget: "返利目标",
        rebateCoefficient: "返利系数",
        quarterlyTasks: "季度分解任务",
        quarterlyTasksMustEquals: "季度分解任务之和必须等于目标数",
        Targetunt: "(万/美元)",
        nation: "国家",
        authRegion: "授权区域",
        region: "区域",
        contractvalid: "合同有效期至",
        upload: "上传",
        detiltitle: "详细信息",
        companyadress: "公司地址",
        raddvad: "签约合作伙伴信息",
        ApplicationReason: "审批理由",
        Email: "联系邮箱",
        ApprovalProcess: "审批流程",
        nodeList: {
          node: "审批流程",
          Approver: "审批节点",
          status: "审批状态",
          date: "审批时间",
          remarks: "审批意见"
        },

        OperationLog: {
          title: "操作记录",
          Operator: "操作人",
          item: "操作项",
          time: "操作时间",
          content: "内容"
        },
        RemarksApproval: "审批意见",
        downmb: "下载签约模板",
        downRz: "Ruijie Networks Authorized Partnership Agreement",
        uploadtip:
          "只能上传 JPG,JPEG, GIF, PNG, PPT, DOC, DOCX, PPTX,PPT, RAR 和 ZIP格式的文件，且不超过 50M",
        poPictureUploadTips:
          "只能上传 JPG,JPEG, GIF, PNG, BMP, RAR 和 ZIP格式的文件，且不超过 50M",
        allowImage:
          "只能上传 BMP、JPG、JPEG、PNG、GIF 格式的文件，且不超过 50M",
        GlobalStrategicPartneradd: "签约战略合作伙伴信息",
        CompanyMail: "公司邮箱",
        readAndAgree: "阅读并同意",
        rzDescription:
          "Thank you for applying the Ruijie partner. It is time to complete your information so that we can better serve you . don’t worry, the process is quick and easy.",
        rzStep1:
          "①To let us better help you, please provide all required information before continuing",
        rzStep2:
          "②Please choose your preferred authorized Ruijie Value-added distributor",
        rzStep3:
          "③Note: In order to verify the authenticity of your information, please upload your company’s business license or a photo taken with Ruijie’s VAD staff and sales staff.",
        salution: "Salution ",
        mobileNumber: "Mobile Number",
        remind: "公司名称请填写准确， 填写后无法修改。",
        picUpload: "图片上传"
      }
    },
    Approvalstate: {
      "1": "审核通过",
      "-1": "驳回",
      "0": "申请"
    }
  },
  en: {
    message: {
      Operation: "Operation",
      select: "Please Select",
      submit: "Submit",
      cancel: "Cancel",
      query: "Query",
      lookat: "View",
      Edit: "Edit",
      besuer: "Confirm",
      Approval: "Approval",
      Reject: "Reject to the first step",
      Rejectnext: "Reject to the last step",
      Resubmit: "Resubmit",
      Reset: "Reset",
      download: "Download",
      needcomName: "Please enter the company name",
      needassignment: "Please enter the target",
      needemail: "Please enter the contact email of partner",
      needecountry: "Please select the country",
      needauthcountry: "Please select authorization region",
      needecity: "Please select the City",
      needesalesName:
        "Please enter the name of the Ruijie sales representative",
      needesalesphone:
        "Please enter the mobile phone number of the Ruijie sales representative",
      needesetUpDate: "Please select the company establishment date",
      needeaddress: "Please enter the company address",
      needepeopleNumber: "Please enter the number of employees",
      needepartnerType: "Please enter the respective VAD",
      needecontractValidity: "Please enter the contract expiration date",
      needeApplicationReason: "Please enter the reason for application",
      needRegisteredCapital: "Please enter the registered capital",
      needname: "Please Enter Your Name",
      needPosition: "Please enter the position",
      needMobile: "Please enter the mobile phone number",
      needEmail: "Please enter the email",
      needoffphone: "Please enter the office phone number",
      needeparentCompanyCode: "Please enter the respective VAD",
      needBusinessFocus: "Please select the Business focus",
      needIndustryFocus: "Please select the Industry focus",
      needIndustryFocusOther: "Please enter the other Industry focus",
      needbeemail: "Please enter an email with valid address format",
      needfile: "Please upload a file",
      uploadError: "Upload Error",
      submitError: "Submit Error",
      submitsuccess: "Submit Success",
      complianceBlockTitle: "Export Compliance Check Failed",
      complianceRiskDetails: "Risk Details",
      complianceRiskLevel: "Risk Level: {level}",
      complianceClose: "Close",
      complianceConfirm: "Confirm",
      complianceAppealMissing: "Appeal parameters are missing. Please try again later",
      complianceAppealSuccess: "Appeal submitted",
      complianceAppealSuccessNo: "Appeal submitted. Interception No.: ",
      complianceAppealFailed: "Failed to submit the appeal. Please try again later",
      complianceFallback: "Export compliance check failed. Please contact the administrator.",
      complianceReviewPending: "An export compliance review has already been initiated for this contract (Review No.: {no}). It is in progress, please wait for the result.",
      complianceReviewRejected: "The export compliance review for this contract was not approved (Review No.: {no}). Please contact the administrator.",
      bindsuccess: "Binding succeeded",
      approveAgree: "Approved",
      approveReject: "Rejected",
      add: "+ Add",
      activation: "Activation",
      activationsuccess: "Activation Successful",
      disable: "Disable",
      disablesuccess: "Disable Successful",
      link: "Link",
      none: "None",
      release: "Release",
      releasesuccess: "Release Successful",
      confirmDisable: "Be sure to disable it?",
      confirmActive: "Be sure to active it?",
      hints: "Hints",
      secondHints: "Second Time Hints",
      save: "Save",
      savesuccess: "Save Successful",
      notnull: "Can't Be Empty",
      manage: "Manage",
      manageUser: "Manage Users",
      manageInterface: "Manage Interface Permissions",
      manageMenu: "Manage Menu Permissions",
      noimage: "Have No Image",
      addChildArea: "新增子区域",
      addParentArea: "新增父区域",
      needCompanyEmail: "Please enter the company email",
      rejectMessage: "Reason",
      bindAccount: "Account-bound",
      bindChannel: "Bind Account",
      confirmDelete: "Are you sure to delete？",
      needFirstName: "Please enter the first name.",
      needLastName: "Please enter the last name.",
      needPassword: "Please enter the password.",
      needBePassword:
        "The password must be 8-16 digits long and must contain uppercase and lowercase letters and numbers. The account number and password cannot be identical.",
      needPhone: "Please enter the phone number.",
      needCompany: "Companies can not be empty.",
      needPositions: "Please select the positions.",
      // emailNotExistsAndRegister:"Account mailbox does not exist. Please enter the following account information for registration binding.",
      emailNotExistsAndRegister:
        "The account email does not exist. Please contact the user to create the account in the following link.",
      needIdentifyCode: "Please enter the ID Number",
      bindRgid: "Create RGID",
      neednamePinyin: "Please Enter Your Name Phonetic Alphabets",
      delete: "Delete",
      confirm: "Confirm",
      pendingApprove: "Pending Approval",
      pass: "Approved",
      approveAgreeMessage: "Are you sure to confirm the approval?",
      operationSuccess: "Operation Successfully Completed",
      needMasterAccount: "Please select the Master Account",
      approAgree: "Approved",
      approReject: "Reject",
      deleteSuccess: "Delete Successful",
      needNewBindAccount: "Please input new bound channel account",
      RejectReason: "Reason To Reject :",
      rgidGuide:
        "• RGID is the unique identification of each candidate for the Ruijie certification test. You are required to use the RGID for test registration, score inquiry, and certificate inquiry.",
      waitUpload: "Please wait for the attachment to be uploaded.",
      needOpinion: "Please input the remarks of approval",
      agree: "Agree",
      needSalution: "Please select the Salution.",
      needMobileNumber: "Please enter the Mobile Number.",
      excel: "Export",
      backpackerReport: "Backpacker Report",
      targetyearnotnull: "Please enter the Target year",
      targetyearinvalid: "Please enter a valid year",
      numeric: "Please enter a positive integer",
      targetAdd: "Add Sales Target",
      targetEdit: "Edit Sales Target",
      partnerTarget: "Sales Target",
      received: "Confirm receive",
      userNameNeedLetters: "Name must be in English",
      bindTips:
        "Attention: Registered name will appear on certificate including blank symbol. Please verify carefully.",
      identityTips: "It is recommended to use personal identification code.",
      deleteReason: "Reasons for deletion",
      needOrderAmount: "Please enter the amount of order",
      needBeAmount: "Please enter a positive number within 12 digits",
      needPoPicture: "Please upload the Picture of PO",
      needBePicture:
        "Please upload files in JPG,JPEG, GIF, PNG, BMP, RAR and ZIP formats",
      approver: "Approver",
      needCooperationPlanUrl: "Please upload Signed Partnership Proposal",
      needRebateCoefficient: "Please enter the Rebate Ratio",
      needSaleTargetQ1: "Please enter the Target of Q1",
      needSaleTargetQ2: "Please enter the Target of Q2",
      needSaleTargetQ3: "Please enter the Target of Q3",
      needSaleTargetQ4: "Please enter the Target of Q4",
      certificate: "Ruijie authorization certificate",
      renewal: "Renewal",
      use: "Use",
      needApprovalOpinion: "Please enter approval comments",
      needAuthRegion: "Please select Authorized Country"
    },
    menu: {
      channecontract: "Pending for Processing",
      channecontractlist: "Pending for Processing",
      ContractInfo: "签约信息",
      ContractInfolist: "签约列表",
      BecomePartne: "Become Our Partne",
      VADadd: "VAD Partner",
      goldpartner: "Gold Certified Partner",
      CertifiedPartner: "Certified Partner",
      FranchisedPartner: "Elite Partner"
    },
    page: {
      certificate: {
        title: "Certificate Information",
        certificateCode: "Certificate No.",
        certificatePreview: "Preview Certificate",
        name: "Name of Engineer",
        authenticationName: "Type of Certification",
        expireDate: "Expiry Date",
        workPost: "Position"
      },
      home: {
        Announcement: "Announcement",
        pictitle1: "Find Partner",
        pictitle2: "Become  Partner",
        partenr: "PARTNER",
        VAD: "VAD Partner",
        goldpartner: "Gold Certified Partner",
        CertifiedPartner: "Certified Partner",
        FranchisedPartner: "Elite Partner",
        usercenter: "User Center",
        banerTtile1: "Tools & Resources",
        banerTtile2: "Launch of  Parnter Management System",
        banercon:
          "Login in to view all tools and resources available to our partners",
        banerbtn: "Resources Center",
        VADdetaile:
          "Being Ruijie's core partner, VAD is responsible for distributing Ruijie products, building Ruijie's brand, and providing value-added services and support for resellers. The value-added services include product assortment, product supply service, credit control of resellers and sales channels.",
        golddetaile:
          "The industry gold partners supply Ruijie products to authorized customers by placing orders with Ruijie’s core distributors. The gold partners are only allowed to supply products to the end customers but not to other partners. They shall comply with Ruijie’s market and pricing regulations and meet the contracted sales targets.",
        Certificationdetaile:
          "The certified partners supply Ruijie products to authorized customers by placing orders with Ruijie’s core distributors. The certified partners are only allowed to supply products to the end customers but not to other partners in compliance with Ruijie’s market and pricing regulations. No contracted sales target is required for the certified partners.",
        Strategydetaile:
          "The elite partners supply Ruijie products to authorized key customers in various industries such as operators, finance, government, military, transportation, electricity and energy. They are only allowed to supply products to the end users."
      },
      ContractInfolist: {
        codeSigning:'Company Code',
        signContract:'Nation',
        contractSales:'Ruijie Sales',
        ContractList: "Contract List",
        ContractInformation: "Contract Information",
        companycode: "Company Code",
        comname: "Company Name",
        target: "Target(USD)",
        TypeofContract: "Type of Contract",
        YearofContract: "Year of Contract",
        DateofContract: "Date of Contract",
        contractvalid: "Contract expiry date"
      },
      channelUserEditVAD: {
        title: "Edit Partner"
      },
      VAD: {
        // VAD 签约方式,新增翻译
        overallAssessmentTasks:'Sale target',
        sharpNetworkRebatesCoefficient:'Enterprise Rebate Ratio',
        easyNetworkRebatesCoefficient:'Reyee Rebate Ratio',
        homeNetworkRebatesCoefficient:'Home Wi-Fi  Rebate Ratio',
        amountHouseholdTasks:' Home Wi-Fi',
        overallAssessment:'Overall assessment',
        separateInspection:'Separate assessment',
        assessmentMethods:'Assessment method',
        quarterlyAssessmentWay:'Assessment method',
        basetitle: "Basic Information",
        comname: "Company Name",
        Target: "Sale target",
        rebateTarget: "Rebate target",
        rebateCoefficient: "Rebate Ratio",
        saleRewardCoefficient: "Reward Multiple",
        quarterlyTasks: "Quarterly Target",
        quarterlyTasksMustEquals:
          "Sum of Quarterly Target Must be equal to target number",
        Targetunt: "(USD)",
        email: "Partner Email",
        nation: "Nation",
        region: "City",
        authRegion: "Authorized Country",
        ruijieSR: "Ruijie Sales",
        ruijieSRemail: "Rujie Sales Email",
        ruijieSRphone: "Ruijie Sales Contact No.",
        contractvalid: "Contract expiry date",
        agreementup: "Annual Bussiness Plan",
        cooperationPlan: "Signed Partnership Proposal",
        agreementfile: "Upload Contract",
        upload: "upload",
        detiltitle: "Detailed Information",
        datefond: "Date of Foundation",
        companyadress: "Company Address",
        companynum: "Number of Employees",
        addvad: "VAD Partner Information",
        raddvad: "Contractual Partner",
        addgold: "Gold Certified Partner Information",
        VADType: "Affiliated VAD",
        Certifiedadd: "Certified Partner Information",
        YPadd: "Silver Partner Information",
        SUBadd: "Sub-Distributor Partner Information",
        ZCPartnerad: "Registered Partner Information",
        ApplicationReason: "Application Reason",
        FranchisedPartneradd: "Elite Partner Information",
        peopleNumber: "Number of Employees",
        RegisteredCapital: "Registered Capital",
        GeneralManager: "General Manager's Profile",
        name: "Name",
        Position: "Position",
        Mobile: "Mobile Phone",
        Email: "Email",
        offphone: "Office Phone",
        SalesSupervisor: "Sales Supervisor",
        CommercialSupervisor: "Commercial Supervisor",
        TechnicalSupervisor: "Technical Supervisor",
        VADInfotitle: "View VAD Partner",
        CertifiedInfotitle: "View Contract – Certified",
        GoldInfotitle: "View Contract – Gold",
        FranchisedInfotitle: "View Franchised Partner",
        YPInfotitle: "View YP Partner",
        SUBInfotitle: "View SUB Partner",
        ZLInfotitle: "View Global Strategic Partner",
        ZCInfotitle: "View Registered Partner",
        ApprovalProcess: "Approval Process",
        nodeList: {
          node: "Approval Node",
          Approver: "Operator",
          status: "Status",
          date: "Date of Approval",
          remarks: "Remarks of Approval"
        },
        VerifyVAD: "Verify VAD Partner",
        VerifyJP: "Verify Gold Certified Partner",
        VerifyRZ: "Verify Certified Partner",
        VerifyYP: "Verify YP Partner",
        VerifySUB: "Verify SUB Partner",
        VerifyZL: "Verify Strategic Partner",
        VerifyZC: "Verify Registered Partner",
        OperationLog: {
          title: "Operation Log",
          Operator: "Operator",
          item: "Operation Item",
          time: "Date of Application",
          content: "Content"
        },
        RemarksApproval: "Remarks of Approval",
        downmb: "Dowload Contract Template",
        downRz: "Ruijie Networks Authorized Partnership Agreement",
        uploadtip:
          "Max 50M,Allowed to upload a JPG,JPEG, GIF, PNG, PPT, DOC, DOCX, PPTX,PPT, RAR and ZIP",
        poPictureUploadTips:
          "Max 50M,Allowed to upload a JPG,JPEG, GIF, PNG, BMP, RAR and ZIP",
        allowImage: "Max 50M,Allowed to upload a JPG,JPEG, GIF, PNG",
        GlobalStrategicPartneradd: "Global Strategic Partner Information",
        CompanyMail: "Contractual Partner Email",
        salesInformation: "Ruijie Sales Information",
        readAndAgree: "Read and Agree",
        rzDescription:
          "Thank you for applying the Ruijie partner. It is time to complete your information so that we can better serve you . don’t worry, the process is quick and easy.",
        rzStep1:
          "①To let us better help you, please provide all required information before continuing",
        rzStep2:
          "②Please choose your preferred authorized Ruijie Value-added distributor",
        rzStep3:
          "③Note: In order to verify the authenticity of your information, please upload your company’s business license or a photo taken with Ruijie’s VAD staff and sales staff.",
        salution: "Salution",
        mobileNumber: "Mobile Number",
        remind:
          "Please make sure to fill in the correct name of the contracted company. The company name cannot be modified after submission.",
        picUpload: "Picture upload",
        tbc: "Ruijie local sales team",
        orderAmount: "Amount of order",
        poPicture: "Picture of PO",
        businessFocus: "Business focus",
        industryFocus: "Industry focus",
        reyee: "Reyee",
        homeNetwork:'Home Wi-Fi',
        enterprise: "Enterprise",
        smb: "SMB"
      },
      pending: {
        ListPending: "List of Contracts Pending for Processing",
        Approvalstate: "Approval State"
      },
      SwitchingIdentity: {
        title: "Switching identity"
      },
      RoleManagement: {
        title: "Role Management",
        roleName: "Role Name",
        status: "Status",
        roleCode: "Role Code",
        updateTime: "Last Modification Time",
        editRole: "Edit Role"
      },
      UserManagement: {
        title: "角色管理",
        userRole: "用户角色",
        userId: "用户编码",
        userName: "用户姓名",
        userEmail: "用户邮箱",
        state: "状态",
        roleCode: "角色编码",
        updateTime: "最后修改时间",
        phoneNumber: "联系电话",
        active: "激活",
        disable: "禁用",
        editUser: "编辑用户",
        edit: "编辑",
        query: "查询",
        reset: "重置"
      },
      Content: {
        ContentManagement: "信息管理",
        title: "标题",
        status: "状态",
        type: "信息类别",
        content: "内容",
        image: "图片",
        link: "链接",
        updateTime: "最后修改时间"
      },
      ContentForm: {
        contentAdd: "添加信息",
        contentEdit: "修改信息",
        baseInfo: "基础信息",
        isNewWindow: "是否打开窗口",
        isBanner: "是否为Banner",
        linkOfNewWindow: "新窗口网址",
        bannerInfo: "Banner信息",
        title: "标题",
        status: "状态",
        type: "类型",
        content: "内容",
        image: "图片",
        link: "链接",
        uploadImage: "上传图片",
        pcBannerTip: "只能上传 JPG、JPEG、PNG 格式的文件，尺寸限制小于2000*700",
        mobileBannerTip:
          "只能上传 JPG、JPEG、PNG 格式的文件，尺寸限制小于800*500",
        newsContent: "内容",
        permissionInfo: "权限信息",
        regionPermission: "是否限制区域",
        region: "授权区域",
        channelPermission: "渠道权限",
        workPosts: "岗位权限",
        isLogin: "是否需要登录",
        permission: "访问权限",
        partnerTypes: "签约类型",
        imagePc: "PC端banner图",
        imageMobile: "移动端banner图"
      },
      RoleUser: {
        userRoleManagement: "User Role Management",
        modify: "Modify",
        role: "Role",
        pleaseInput: "Please Input",
        notInGroupUsers: "Not In Group Users",
        list: "List"
      },
      AreaTableHeader: {
        areaTableTitle: "区域管理",
        levelHeaderName: "级别",
        areaHeaderName: "区域名称",
        upperAreaHeaderName: "所属区域",
        creatTime: "创建时间",
        operate: "操作"
      },
      templ: {
        TemplateManager: "签约模板管理",
        TemplateAdd: "新增模板",
        TemplateEdit: "编辑模板",
        path: "路径",
        fileName: "文件名称",
        templType: "模板类型",
        createTime: "创建时间",
        partnerType: "签约类型",
        authRegion: "授权区域"
      },
      RoleMenu: {
        roleMenuManagement: "Role Menu Management",
        modify: "Modify",
        menuDisplayPermissions: "Menu Display Permissions"
      },
      RoleInterface: {
        roleInterfaceManagement: "Role Interface Management",
        modify: "Modify",
        interfaceCallAuthority: "Interface Call Authority"
      },
      Account: {
        masterAccountTitle: "Account Binding",
        subAccountName: "Sub-account Name",
        subAccount: "Sub-account",
        subAccountMail: "Sub-account Email",
        workPost: "Work Position",
        contactPhone: "Contact Number",
        operate: "Operation",
        addSubAccount: "Add sub-account",
        transferToAnother: "Transfer sub-account",
        transferSubAccountNote:
          "Note: After the transfer, the selected sub-account will be transferred to the new main account which cannot be undone. ",
        transferSubAccountSuccess:
          "The sub-account has been successfully transferred",
        needTransferMasterAccount:
          "Please select the sub-account you want to transfer",
        editSubAccount: "Edit sub-account",
        firstName: "First Name",
        lastName: "Last Name",
        password: "Password",
        phoneNumber: "Phone Number",
        country: "Country",
        company: "Company/Organization",
        masterAccount: "Master Account",
        masterAccountName: "Company Name",
        status: "Status",
        bindMasterAccount: "Bind Channel Master Account",
        changeMasterAccount: "Change Channel Master Account",
        pendingTitle: "Pending Account-Bound",
        bindAccount: "Bound Channel Account",
        newBindAccount: "New Bound Channel Account",
        name: "Name",
        credentialsType: "ID Type",
        credentialsNum: "ID Number",
        recipient: "证件接收人",
        postAddress: "邮寄地址",
        postCode: "邮编",
        selPhoneNum: "手机号",
        myRgeidTitle: "My RGID",
        cancel: "Cancel",
        submitBind: "Submit Bind",
        reSubmit: "ReSubmit",
        showRejectReason: "Show Reject Reason",
        approvalMan: "Approver",
        approvalOpinion: "Approval Opinion",
        approvalTime: "Approval Tine",
        rejectHistory: "Reject History",
        modify: "Modify",
        namePinYin: "Name Pin Yin",
        typesValidIds: "Identity Card",
        masterAccountEmail: "Master Account Email",
        masterAccountInstructions:
          "if you want to bind sub-account, please click Add sub-account.",
        boundVadSaleName: "VAD/Sub-D Sales"
      },
      resourcesList: {
        category: "Category:"
      },
      InfoCatManagement: {
        parentCat: "父类别",
        rootCat: "一级类别",
        secondCat: "二级类别"
      },
      lier2partnerlist: {
        title: "Tier2 Partner List",
        email: "Email",
        dateRegister: "Date of Register",
        dateRegisterStart: "Date of Register Start",
        dateRegisterEnd: "Date of Register End",
        certified: "Certified",
        recertified: "ReCertified",
        hints: "please confirm the company already completed the first order",
        guid:
          "Please click “Certified ”after the partner placed first order. The partner will become Ruijie Certified partner  after Ruijie sales approval.",
        registerNumber: "Registered Partner Numbers：",
        certifiedNumber: "Certified  Partner Numbers："
      },
      PartnerTargets: {
        targetYear: "Target Year",
        salesVolumeTarget: "Sales volume target",
        targetRegistered: "Target of development/registered partner",
        targetCertified: "Target of development/certified partner",
        targetRegisteTitle: "Target of development registered partner",
        targetCertifTitle: "Target of development certified partner",
        createTime: "Create Time"
      },
      rebate: {
        title: "Rebate",
        company: "Company Name",
        rebateType: "Rebate types"
      },
      ApReceive: {
        title: "AP领取登记",
        remind:
          "如果您已经领取AP，请点击已领取按钮，如果未领取，请联系您所属的VAD或者销售",
        confirm: "确认已经领取AP吗？"
      },
      // RDP, RAD签约流程
      signUpProcess: {
        // start
        address: "Address",
        website: "Website",
        contractgoal: "Contract Goal",
        contact: "Contact",
        email: "Email",
        businesslicense: "Business License",
        contractAgreement: "Contract Agreement",
        businessPlan: "Business Plan",
        approveCountrManager: "Approve by Country General Manager",
        approveRegionalManager: "Approve by Regional General Manager",
        rejectToFirstNode: "Reject to First Node",
        // end
        basetitle: "Basic Information",
        comname: "Company Name",
        Target: "Sale target",
        rebateTarget: "Rebate target",
        rebateCoefficient: "Rebate Ratio",
        saleRewardCoefficient: "Reward Multiple",
        quarterlyTasks: "Quarterly Target",
        quarterlyTasksMustEquals:
          "Sum of Quarterly Target Must be equal to target number",
        Targetunt: "(USD)",
        // email:"Partner Email",
        nation: "Nation",
        region: "City",
        authRegion: "Authorized Country",
        contractvalid: "Contract expiry date",
        upload: "upload",
        detiltitle: "Detailed Information",
        companyadress: "Company Address",
        raddvad: "Contractual Partner",
        ApplicationReason: "Application Reason",
        Email: "Email",
        ApprovalProcess: "Approval Process",
        nodeList: {
          node: "Approval Node",
          Approver: "Operator",
          status: "Status",
          date: "Date of Approval",
          remarks: "Remarks of Approval"
        },
        VerifyVAD: "Verify VAD Partner",
        VerifyJP: "Verify Gold Certified Partner",
        VerifyRZ: "Verify Certified Partner",
        VerifyYP: "Verify YP Partner",
        VerifySUB: "Verify SUB Partner",
        VerifyZL: "Verify Strategic Partner",
        VerifyZC: "Verify Registered Partner",
        OperationLog: {
          title: "Operation Log",
          Operator: "Operator",
          item: "Operation Item",
          time: "Date of Application",
          content: "Content"
        },
        RemarksApproval: "Remarks of Approval",
        downmb: "Dowload Contract Template",
        downRz: "Ruijie Networks Authorized Partnership Agreement",
        uploadtip:
          "Max 50M,Allowed to upload a JPG,JPEG, GIF, PNG, PPT, DOC, DOCX, PPTX,PPT, RAR and ZIP",
        poPictureUploadTips:
          "Max 50M,Allowed to upload a JPG,JPEG, GIF, PNG, BMP, RAR and ZIP",
        allowImage: "Max 50M,Allowed to upload a JPG,JPEG, GIF, PNG",
        GlobalStrategicPartneradd: "Global Strategic Partner Information",
        CompanyMail: "Contractual Partner Email",
        readAndAgree: "Read and Agree",
        rzDescription:
          "Thank you for applying the Ruijie partner. It is time to complete your information so that we can better serve you . don’t worry, the process is quick and easy.",
        rzStep1:
          "①To let us better help you, please provide all required information before continuing",
        rzStep2:
          "②Please choose your preferred authorized Ruijie Value-added distributor",
        rzStep3:
          "③Note: In order to verify the authenticity of your information, please upload your company’s business license or a photo taken with Ruijie’s VAD staff and sales staff.",
        salution: "Salution",
        mobileNumber: "Mobile Number",
        remind:
          "Please make sure to fill in the correct name of the contracted company. The company name cannot be modified after submission.",
        picUpload: "Picture upload"
      }
    },
    Approvalstate: {
      "1": "Approved",
      "-1": "Reject",
      "0": "Application"
    }
  }
};



// WEBPACK FOOTER //
// ./src/locale/locale.js